import { CSSProperties } from "react";

import { useTranslations } from "next-intl";

import { cn } from "@/utils/cn";

type DividerVariant = "horizontal" | "vertical";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  withTitle?: boolean;
  style?: CSSProperties;
  variant?: DividerVariant;
}

export const Divider = ({
  title = "or",
  withTitle = false,
  style,
  className,
  variant = "horizontal",
}: Props) => {
  const t = useTranslations();

  const isHorizontal = variant === "horizontal";

  return (
    <>
      {withTitle ? (
        <div
          className={cn(
            "flex items-center justify-center font-semibold text-gray",
            isHorizontal
              ? "w-full text-[17px] before:content-[''] before:flex-1 before:h-[0.1rem] before:bg-gray before:mr-4 after:content-[''] after:flex-1 after:h-[0.1rem] after:bg-gray after:ml-4"
              : "h-full flex-col text-[17px] before:content-[''] before:flex-1 before:w-[0.1rem] before:bg-gray before:mb-4 after:content-[''] after:flex-1 after:w-[0.1rem] after:bg-gray after:mt-4",
            className,
          )}
          style={style}
        >
          {t(`${title}`)}
        </div>
      ) : (
        <hr
          className={cn(
            isHorizontal
              ? "w-full border-b border-solid border-gray/35"
              : "h-full border-r border-solid border-gray/35",
            className,
          )}
          style={style}
        />
      )}
    </>
  );
};
